import React from 'react';
import PropTypes from 'prop-types';
import { isGroup, isConjointOrMaxDiffGroup } from 'utils/nodeTypes';
import GenericQuestionViewOnly from 'containers/TemplatePreviewPage/QuestionsListViewOnly/GenericQuestionViewOnly/index';
import QuestionGroupViewOnly from 'containers/TemplatePreviewPage/QuestionsListViewOnly/QuestionGroupViewOnly/index';
import { TEMPLATE_MOBILE_VIEWPORT } from 'containers/TemplatePreviewPage/constants';
import { useWindowSize } from 'utils/hooks';

const QuestionListViewOnly = ({ nodes = [], screeningQuestions = [] }) => {
  const { width: viewportWidth } = useWindowSize();
  const isMobileViewport = viewportWidth <= TEMPLATE_MOBILE_VIEWPORT;

  return nodes.map((node) => {
    if (isGroup(node)) {
      const isConjointOrMaxDiffType = isConjointOrMaxDiffGroup(node.type);
      const shouldRenderSubquestions = !isConjointOrMaxDiffType;
      return (
        <QuestionGroupViewOnly
          key={node.refId}
          group={node}
          hideActions={isMobileViewport}
        >
          {shouldRenderSubquestions &&
            node.questions.map((question) => (
              <GenericQuestionViewOnly
                key={question.refId}
                question={question}
                nodes={node.questions}
                screeningQuestions={screeningQuestions}
                hideActions={isMobileViewport}
              />
            ))}
        </QuestionGroupViewOnly>
      );
    }

    return (
      <GenericQuestionViewOnly
        key={node.refId}
        question={node}
        nodes={nodes}
        screeningQuestions={screeningQuestions}
        readOnly
        hideActions
      />
    );
  });
};
QuestionListViewOnly.propTypes = {
  nodes: PropTypes.array.isRequired,
};

export default QuestionListViewOnly;
